import register from 'preact-custom-element'
import { setRecentlyProducts } from 'helpers/recently-product'
import ProductForm from 'snippets/product/product-form/product-form'
import ProductBadges from 'snippets/product-badges/product-badges'
import ProductUpsellCarousel from 'snippets/product/product-upsell-carousel/product-upsell-carousel'
import ProductStickyATC from 'snippets/product/product-sticky/product-sticky-atc'
import ProductFormSticky from 'snippets/product/product-sticky/product-form-sticky'

let devtools

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require , no-unused-vars
  devtools = require('preact/devtools')
}

class ProductMain extends HTMLElement {
  constructor() {
    super()
    setRecentlyProducts(this.dataset.id)

    if (localStorage.getItem('return_to')) {
      localStorage.removeItem('return_to')
    }
  }
}

register(ProductForm, 'product-form')
register(ProductBadges, 'product-badges')
register(ProductUpsellCarousel, 'product-upsell-carousel')
register(ProductStickyATC, 'product-sticky-atc')
register(ProductFormSticky, 'product-form-sticky')

customElements.define('product-main', ProductMain)
